/*
 * Ryan O'Dowd
 * 2025-05-23
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = () => {
  return {
    drawerStyle: { // @TODO: why aren't these styles working?
      // @TODO: minWidth: globalScale * 300,
      // @TODO: width: '30%',
      // @TODO: maxWidth: '90%',
      // @TODO: backgroundColor: 'salmon',
      // @TODO: height: '110%',
      // @TODO: minHeight: '110%',
    },
  };
};

export default getStyles;
